import { render } from "./EmptyStateDashboard.vue?vue&type=template&id=7901f2aa"
import script from "./EmptyStateDashboard.vue?vue&type=script&lang=js"
export * from "./EmptyStateDashboard.vue?vue&type=script&lang=js"

import "./EmptyStateDashboard.vue?vue&type=style&index=0&id=7901f2aa&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__